import request from '@/utils/request';
import { fileService } from "@/api/common/file-utils";
import commonFun from "@/utils/commonFun";


export default {
    getRateGroup: (param) => {
        return request({
            url: `/fpaPermanent/getLogisticFareDectionary`,
            method: 'post',
            data: param
        });
    },
    getRateItem: (param, rateGroup) => {
        return request({
            url: `/fpaPermanent/getLogisticDectionaryByRateGroup/${rateGroup}`,
            method: 'post',
            data: param
        });
    },
    fpaLtoCampaignList: (queryType, param) => {
        return request({
            url: `/fpaLtoCampaign/fpaLtoCampaignList?queryType=${queryType}`,
            method: 'post',
            data: param
        });
    },

    fpaLtoCampaignDelete: (param) => {
        return request({
            url: `/fpaLtoCampaign/fpaLtoCampaignDelete`,
            method: 'post',
            data: param
        });
    },
    saveMarks: (param) => {
        return request({
            url: `/fpaLtoCampaign/saveMarks`,
            method: 'post',
            data: param
        });
    },

    fpaLtoCampaignSave: (param) => {
        return request({
            url: `/fpaLtoCampaign/fpaLtoCampaignSave`,
            method: 'post',
            data: param
        });
    },

    fpaPdfDownload: (param) => {
        return request({
            url: `/fpaLtoCampaign/fpaPdfDownload`,
            fullResponse: true,
            responseType: 'blob',
            method: 'post',
            data: param
        });
    },

    fpaLtoCampaignDetail: (ttFpaLtoCampaignId) => {
        return request({
            url: `/fpaLtoCampaign/fpaLtoCampaignDetail?ttFpaLtoCampaignId=` + ttFpaLtoCampaignId,
            method: 'get',
            data: ttFpaLtoCampaignId
        });
    },

    nfcAdminSubmit: (param) => {
        return request({
            url: `/fpaLtoCampaign/nfcAdminSubmit`,
            method: 'post',
            data: param
        });
    },
    fpaLtoMenuVpApprove: (param) => {
        return request({
            url: `/fpaLtoCampaign/fpaLtoMenuVpApprove`,
            method: 'post',
            data: param
        });
    },
    fpaLtoScmVpApprove: (param) => {
        return request({
            url: `/fpaLtoCampaign/fpaLtoScmVpApprove`,
            method: 'post',
            data: param
        });
    },
    fpaWithdraw: (param) => {
        return request({
            url: `/fpaLtoCampaign/withdraw`,
            method: 'post',
            data: param
        })
    },
    fpaLtoCfoApprove: (param) => {
        return request({
            url: `/fpaLtoCampaign/fpaLtoCfoApprove`,
            method: 'post',
            data: param
        });
    },
    fpaLtoCeoApprove: (param) => {
        return request({
            url: `/fpaLtoCampaign/fpaLtoCeoApprove`,
            method: 'post',
            data: param
        });
    },
    fpaLtoCgoApprove: (param) => {
        return request({
            url: `/fpaLtoCampaign/fpaLtoCgoApprove`,
            method: 'post',
            data: param
        })
    },

    audit: (param) => {
        return request({
            url: `/fpaLtoCampaign/audit`,
            method: 'post',
            data: param
        });
    },

    fpaLtoReject: (param) => {
        return request({
            url: `/fpaLtoCampaign/fpaLtoReject`,
            method: 'post',
            data: param
        });
    },

    fpaLtoNfsDownload: (param) => {
        return request({
            url: `/fpaLtoCampaign/fpaLtoNfsDownload`,
            fullResponse: true,
            responseType: 'blob',
            method: 'post',
            data: param
        });
    },
    exportPqcn: (param) => {
        return request({
            url: `/fpaLtoCampaign/exportPQCN`,
            fullResponse: true,
            responseType: 'blob',
            method: 'post',
            data: param
        }).then(res => {
            fileService.respToFile(res);
        })
    },
    getCategoryLeader: (param) => {
        return request({
            url: `/categoryLeader/findList`,
            method: 'post',
            data: param
        })
    }

}